@use 'style/utils';
@use 'shared';

$_CLASS: '.joy-divider-cta';

:host {
    --divider-border-color: var(--joy-color-neutral-30);
    --divider-title-color: var(--joy-color-neutral-60);
    --divider-icon-background-color: var(--joy-color-secondary-10);
    --divider-icon-color: var(--joy-color-secondary-30);

    display: block;
    width: 100%;
}

#{$_CLASS} {
    @include shared.defaultStyle();
    padding: var(--joy-core-spacing-4);
    border: 2px dashed var(--divider-border-color);
    cursor: pointer;
    width: 100%;
    box-sizing: border-box;
    transition: all var(--joy-transition-duration-short) var(--joy-transition-timing-function);
    background: none;
    outline: none;

    &__disabled {
        --divider-border-color: var(--joy-color-neutral-30);
        --divider-title-color: var(--joy-color-neutral-40);
        --divider-icon-background-color: var(--joy-color-neutral-30);
        --divider-icon-color: var(--joy-color-neutral-40);

        cursor: not-allowed;
        user-select: none;
    }

    &--icon {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: var(--joy-core-spacing-4);

        width: 40px;
        height: 40px;
        background-color: var(--divider-icon-background-color);
        border-radius: var(--joy-core-radius-2);

        joy-icon {
            color: var(--divider-icon-color);
        }
    }

    &--content {
        text-align: left;
        color: var(--joy-color-neutral-40);
        @include utils.getFontProperties(primary-300);

        &---title {
            color: var(--divider-title-color);
            margin: 0;
            padding: 0;
            font-size: var(--joy-font-size-primary-400);
            font-weight: var(--joy-font-weight-bold);
        }
    }

    &:not(#{$_CLASS}__disabled):hover {
        --divider-border-color: var(--joy-color-secondary-30);
    }

    &:not(#{$_CLASS}__disabled):focus-visible {
        --divider-title-color: var(--joy-color-secondary-50);
        --divider-border-color: var(--joy-color-secondary-50);
    }
}

